/**
 * Format a date string (YYYY-MM-DD or ISO datetime) to "Month Day, Year"
 * e.g., "2026-02-14" → "February 14, 2026"
 */
export function formatDate(dateStr) {
  if (!dateStr) return '';
  // Append T00:00:00 for date-only strings to avoid timezone shift
  const date = dateStr.length === 10
    ? new Date(dateStr + 'T00:00:00')
    : new Date(dateStr);
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}
